import React, { forwardRef } from 'react'

interface PointsBadgeProps {
	points: number
	isCompleted?: boolean
}

const PointsBadge = forwardRef<HTMLDivElement, PointsBadgeProps>(
	({ points, isCompleted = false }, ref) => {
		return (
			<div
				ref={ref}
				className={`${
					isCompleted ? 'bg-gray-300 text-gray-500' : 'bg-[#ffc13e] text-text-dark'
				} flex flex-row items-center gap-2 mt-1 w-fit px-2 py-1 rounded-full text-md`}
			>
				<div
					className={`flex items-center justify-center h-full aspect-square rounded-full ${
						isCompleted ? 'bg-gray-200' : 'bg-[#ffe09e]'
					}`}
				>
					<img
						src='/assets/star-light.svg'
						alt='star'
						className={`h-5 w-5 m-[0.125rem] ${isCompleted ? 'opacity-50' : ''}`}
					/>
				</div>
				+{points}
			</div>
		)
	}
)

PointsBadge.displayName = 'PointsBadge'

export default PointsBadge
